<div class="header"
     [ngClass]="{'header-is-inventory':isInventoryHeader}">
  @if (!showSearchBar && !showSearchDetail) {
  <div class="title-container">
    <mat-icon class="pointer side-menu-action"
              [svgIcon]="menuIcon"
              [ngClass]="{'is-inventory':isInventory}"
              (click)="toggleSideMenu()"></mat-icon>
    <div class="heading">
      <span class="title">{{ title | translate}}</span>
      @if (!pageDescription && subTitle) {
      <span class="sub-title">
        @if (parentTitle) {
        <span>{{ parentTitle | translate}} / </span>
        }
        {{ subTitle | translate}} / {{ title | translate}}
      </span>
      }
      @if (pageDescription) {
      <span class="sub-title">{{ pageDescription | translate}}</span>
      }
    </div>
  </div>
  }
  @if (!showSearchBar && !showSearchDetail && showTabMenus) {
  <div class="tab-container">
    @for (tabMenu of tabMenus; track tabMenu) {
    <div class="tab-menu-item"
         [ngClass]="{'tab-disabled':(tabMenu.index === 5 && caseStatusIndex < 5) || tabMenu.index > (caseStatusIndex + 1) || !caseId || showNoAccess,'text-primary': tabMenu.active}"
         (click)="tabChanged(tabMenu)">
      <label for=""
             [ngClass]="{'text-primary': tabMenu.active}">{{tabMenu.title | translate}}</label>
    </div>
    }
  </div>
  }
  <div class="menu-container"
       [ngStyle]="{'flex' : showSearchBar  || showSearchDetail ? '1': 'unset'}">
    @if (showAiStudioPlanTag && !showSearchBar && !showSearchDetail) {
    <a *xaCheckPermission="{'serviceName': 'Addenda Auto', 'permissionKey': 'ai.studio.agent.subscription' }"
       class="ai-studio-plan-tag"
       [title]="aiStudioPlanTagLabel"
       routerLink="/ai-studio/subscriptions">
      {{ aiStudioPlanTagLabel }}
    </a>
    }
    @if (!showSearchBar && !showSearchDetail) {
    <div class="menu">
      <div class="avatar"
           mat-button
           [matMenuTriggerFor]="menu">
        @if (avatar) {
        <img alt="avatar"
             [src]="avatar"
             (error)="avatar='';" />
        } @else {
        <label for="">{{avatarText}}</label>
        }
        <ng-template #text>
          <label for="">{{avatarText}}</label>
        </ng-template>
      </div>
      <mat-menu #menu="matMenu"
                xPosition="before"
                backdropClass="profile-mat-menu">
        <div mat-menu-item
             (click)="openProfile()">
          <mat-icon svgIcon="person-add-circle"
                    aria-hidden="false"
                    aria-label="profile icon"
                    color="black"></mat-icon>{{ 'my_profile' | translate}}
        </div>
        <div class="separator"></div>
        @if (userSelectionService.multiBranchAccess) {
        <div mat-menu-item
             (click)="switchOrganization()">
          <mat-icon svgIcon="swap-horizontal-circle"
                    aria-hidden="false"
                    aria-label="profile icon"
                    color="black"></mat-icon>{{ 'switch_organization' | translate}}
        </div>
        <div class="separator"></div>
        }
        <div mat-menu-item
             (click)="logout()">
          <mat-icon [svgIcon]="'logout'"
                    aria-hidden="false"
                    aria-label="logout icon"></mat-icon>
          {{ 'logout' | translate}}
        </div>
      </mat-menu>
    </div>
    }
    @if (!showSearchBar && !showSearchDetail && !hasClaimPermission && !hasQuoteAssessmentPermission &&
    !hasFnolPermission) {
    <div>
      <xa-select [(ngModel)]="selectedLang"
                 [config]="config"
                 [options]="options"
                 (ngModelChange)="onLangChange()"></xa-select>
    </div>
    }
    <ng-container *chqPermission="'notification'">
      @if (!showSearchBar && !showSearchDetail && (hasRepairPermission || hasClaimPermission ||
      hasQuoteAssessmentPermission || hasAutoPermission || hasSalesPermission || hasProcurementPermission ||
      hasSurveyorPermission || hasAccountingPermission)) {
      <div class="menu"
           [matMenuTriggerFor]="notificationsMenu"
           #notificationsMenuTrigger="matMenuTrigger">
        <mat-icon [svgIcon]="'bell'"
                  aria-hidden="false"
                  aria-label="notification icon"></mat-icon>
        <span class="notification-unread-counter"
              [hidden]="notificationList.length === 0 || notificationUnreadCount === 0">{{
          notificationUnreadCount
          }}</span>
        <mat-menu #notificationsMenu="matMenu"
                  xPosition="before"
                  backdropClass="notification-mat-menu">
          <div class="w-100 notification-menu-body"
               (click)="stopEventPropagation($event)"
               (keypress)="stopEventPropagation($event)">
            <div class="notification-header">
              <h3>{{'notifications' | translate}}</h3>
              <div class="w-100 flex justify-space-between"
                   [ngClass]="{'text-muted':+notificationUnreadCount === 0}"
                   style="padding: 28px 0;">
                <span>{{notificationTotalCount}} messages</span>
                <a (click)="setAllNotificationsRead()"
                   [hidden]="notificationList.length === 0">{{'mark_all_read' | translate}}</a>
              </div>
            </div>
            @if (notificationLoading && notificationList.length === 0) {
            <div class="notification-details-panel notification-skeleton">
              <div class="skeleton">
                <div class="notification-skeleton-row">
                  <app-skeleton width="75%"></app-skeleton>
                  <app-skeleton width="35%"
                                class="mt-1"></app-skeleton>
                </div>
                <div class="notification-skeleton-row">
                  <app-skeleton width="65%"></app-skeleton>
                  <app-skeleton width="30%"
                                class="mt-1"></app-skeleton>
                </div>
                <div class="notification-skeleton-row">
                  <app-skeleton width="80%"></app-skeleton>
                  <app-skeleton width="28%"
                                class="mt-1"></app-skeleton>
                </div>
                <div class="notification-skeleton-row">
                  <app-skeleton width="70%"></app-skeleton>
                  <app-skeleton width="32%"
                                class="mt-1"></app-skeleton>
                </div>
                <div class="notification-skeleton-row">
                  <app-skeleton width="60%"></app-skeleton>
                  <app-skeleton width="25%"
                                class="mt-1"></app-skeleton>
                </div>
              </div>
            </div>
            } @else if (notificationTotalCount === 0) {
            <div class="fx-col align-center gap-10 text-center no-notification">
              <img alt='no-data'
                   src="assets/img/no-data.png"
                   style="margin: 100px 0px 15px; object-fit: contain;" />
              <span>{{'no_notifications' | translate}}</span>
              <span>{{'no_notifications_msg' | translate}}</span>
            </div>
            }
            <div class="separator-100"
                 [hidden]="notificationTotalCount === 0 || notificationLoading"></div>
            @if (notificationTotalCount !== 0) {
            <div class="notification-details-panel"
                 #notificationScrollPanel
                 (scroll)="onNotificationPanelScroll($event)">
              @for (item of notificationList; track item) {
              <div (click)="setNotificationRead(item)"
                   class="notification-detail">
                <div [innerHTML]="item.Title"
                     class="notification-title"></div>
                @if (item.CreatedDate) {
                <ng-container>
                  <label for="">{{ checkAgoFormat(item.CreatedDate)}}</label>
                </ng-container>
                }
                @if (!item.IsRead) {
                <span class="notification-unread-dot"></span>
                }
                @if (item.isShowActionButton) {
                <button type="button"
                        class="btn-primary col-12 notification-button"
                        (click)="notificationNavigate($event,item.Data?.RepairGuid || item.Data?.ObjectGuid, item.Data?.Action, item)">
                  {{ item.actionButtonText | translate }}
                </button>
                }
                <div class="separator-100"></div>
              </div>
              }
              @if (notificationLoadingMore) {
              <div class="notification-load-more skeleton">
                <div class="notification-skeleton-row">
                  <app-skeleton width="70%"></app-skeleton>
                  <app-skeleton width="35%"
                                class="mt-1"></app-skeleton>
                </div>
                <div class="notification-skeleton-row">
                  <app-skeleton width="55%"></app-skeleton>
                  <app-skeleton width="30%"
                                class="mt-1"></app-skeleton>
                </div>
              </div>
              }
            </div>
            }
          </div>
        </mat-menu>
      </div>
      }
    </ng-container>

    @if (hasHelpPermission) {
    <div class="menu">
      <mat-icon svgIcon="help-box-outline"
                aria-hidden="false"
                (click)="navigateToHelpSection()"
                aria-label="help icon"></mat-icon>
    </div>
    }

    <ng-container *xaCheckPermission="{serviceName: 'Addenda Repair', 'permissionKey': 'whatsapp.general'}">
      @if (this.whatsAppEnabled || this.whatsappTotalMessageCount > 0) {
      @if (!showSearchBar && !showSearchDetail && hasRepairPermission) {
      <div class="menu"
           (click)="openChatWindow();">
        <mat-icon svgIcon="messaging"
                  aria-hidden="false"
                  aria-label="whatsapp icon"></mat-icon>
        <span class="notification-unread-counter"
              [hidden]="generalCommunicationMessagesCount === 0">{{ generalCommunicationMessagesCount
          }}</span>
      </div>
      }
      }
    </ng-container>

    @if (!showSearchBar && !showSearchDetail && (hasRepairPermission || hasQuotePermission)) {
    <div class="menu"
         (click)="showSearchBar=true;">
      <mat-icon svgIcon="search"
                aria-hidden="false"
                aria-label="search icon"></mat-icon>
    </div>
    }
    @if (showSearchBar) {
    <chq-search-bar (closeSearchBar)="close();"
                    (handleMoreResultClick)="loadMorePages($event);"
                    [placeHolder]="searchPlaceHolder"
                    [isClaimModule]="hasClaimPermission || hasSurveyorPermission"></chq-search-bar>
    }
    @if (showSearchDetail) {
    <chq-search-detail (closeSearch)="close();"
                       [searchKeyName]="searchKeyName"
                       [isClaimModule]="hasClaimPermission || hasSurveyorPermission"
                       [searchKey]="searchResultString"></chq-search-detail>
    }

    @if (showHrmCheckIn && !showSearchBar && !showSearchDetail) {
    <div class="hrm-check-in">
      <div class="hrm-check-in__timer"
           [attr.title]="('effective_hours' | translate) + ': ' + effectiveDisplay
                          + ' · ' + ('gross_hours' | translate) + ': ' + grossDisplay">
        <span class="hrm-check-in__timer-value">{{ effectiveDisplay }}</span>
      </div>
      @if (canCheckIn) {
      <xa-button borderType="modern"
                 type="primary"
                 color="primary"
                 size="sm"
                 class="hrm-check-in__btn"
                 (click)="toggleCheckInOut()">
        <mat-icon [svgIcon]="'alarm-clock'"
                  class="hrm-check-in__icon"
                  aria-hidden="true"></mat-icon>
        {{ 'check_in' | translate }}
      </xa-button>
      }
      @if (canCheckOut) {
      <xa-button borderType="modern"
                 type="primary"
                 color="primary"
                 size="sm"
                 class="hrm-check-in__btn"
                 (click)="toggleCheckInOut()">
        <mat-icon [svgIcon]="'alarm-clock'"
                  class="hrm-check-in__icon"
                  aria-hidden="true"></mat-icon>
        {{ 'check_out' | translate }}
      </xa-button>
      }
    </div>
    }
  </div>
</div>


<mat-sidenav-container class="messaging-sidenav-container">
  <mat-sidenav #messaging
               class="messaging-sidenav"
               [fixedInViewport]="true"
               [mode]="'over'"
               [position]="'end'">
    @if (messaging.opened) {
    <chat (closeNav)="closeNav($event)"
          [ConversationGuid]="ConversationGuid"
          [customerMobileNumber]="customerMobileNumber"
          [isGeneralCommunication]="true"> </chat>
    }
  </mat-sidenav>
</mat-sidenav-container>